<script lang="ts">
  import { useCoreStore } from '@/ui/state/use-core-state.svelte';
  import { useSubscriptionConfig } from '@/utils/use-subscription-config.svelte';

  import LoginBootError from './cmps/LoginBootError.svelte';
  import LoginCard from './cmps/LoginCard.svelte';
  import LoginFooter from './cmps/LoginFooter.svelte';
  import LoginLoading from './cmps/LoginLoading.svelte';
  import LoginDialog from './LoginDialog.svelte';

  let CS = useCoreStore();
  const config = useSubscriptionConfig();
  let phase = $derived($CS.bootPhase);
</script>

{#if phase !== 'ready'}
  <div class="flex h-full flex-col">
    <main
      class="flex h-full flex-1 items-center justify-center rounded-lg bg-gradient-to-b from-login-start to-login-end shadow-login"
    >
      <LoginCard customerLogo={config.current.data?.customer_logo}>
        {#if phase === 'anonymous'}
          <LoginDialog />
        {:else if phase === 'error'}
          <LoginBootError message={$CS.bootError} />
        {:else}
          <LoginLoading />
        {/if}
      </LoginCard>
    </main>

    <LoginFooter></LoginFooter>
  </div>
{/if}
